import styled from "@emotion/styled";
import {
  Grid,
  GridColumn,
  MediaQueries,
} from "@polestar/component-warehouse-react";

import DescriptionListItem from "./DescriptionListItem";

import { type IAccordionPanelTable } from "~/types";

interface Props {
  table: IAccordionPanelTable;
}

const StyledGrid = styled(Grid)`
  grid-gap: 0;

  ${MediaQueries.tablet} {
    grid-gap: 0;
  }
  ${MediaQueries.mobile} {
    grid-gap: 0;
  }
`;

const DescriptionList: React.FC<Props> = ({ table }) => {
  const [lableKey, valueKey] = table.columns;
  const hasKeyValueLabels = lableKey && valueKey;

  return (
    <StyledGrid as="dl">
      <GridColumn
        // See https://dequeuniversity.com/rules/axe/4.4/definition-list?application=axeAPI
        aria-hidden
        span={{ mobile: 4, tablet: 8, desktop: 12, desktopWide: 12 }}
      />
      {hasKeyValueLabels &&
        table.data.map((row) => {
          const label = row[lableKey];
          const value = row[valueKey];

          return (
            <DescriptionListItem
              key={`${label}-${value}`}
              label={label}
              value={value}
            />
          );
        })}
    </StyledGrid>
  );
};

export default DescriptionList;
